var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact__info-item"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"info-item-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(": "+_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }